import React, { useState, useEffect } from "react";
import {
  AppBar as MuiAppBar,
  Toolbar,
  Box,
  Button,
  TextField,
  Popover,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip, Switch, FormControlLabel
} from "@mui/material";
// import MenuIcon from '@mui/icons-material/Menu';
import logo from "../../src/assests/images/logo.svg";
import bellicon from "../../src/assests/images/bellicon.svg";
import profileImg from "../../src/assests/images/profile.svg";
import serachicon from "../../src/assests/images/search_icon.svg";
import ActivityIcon from "../../src/assests/images/activity.svg";
import Arrow from "../../src/assests/images/arrow-right-line.svg";
import Setting from "../../src/assests/images/setting.svg";
import InputAdornment from "@mui/material/InputAdornment";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import Notifications from "./Notification/Notifications";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SettingsIcon from "@mui/icons-material/Settings";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { profile } from "./ProfileApi";
import { decodeJWT, getToken } from "../utils/utils";
import { styled } from "@mui/material/styles";
type AppBarProps = {
  onMenuClick: () => void;
  checked: boolean; setChecked: (val: boolean) => void 
}



const AppBar: React.FC<AppBarProps> = ({ onMenuClick,checked ,setChecked}) => {
  // Popover for logout //

    const token = getToken();
  const decodedToken = decodeJWT(token);
    console.log(decodedToken, "decodedTokendecodedTokendecodedToken",token, "tokentokentokentoken")
    const userRole = decodedToken?.user_role_name || "guest";
       const mainroles = decodedToken?.roleNames || "guest";
    console.log(userRole, "kksssssssss")
    console.log(mainroles, "mainrolesmainrolesmainroles")
    
const TextSwitch = styled(Switch)(({ theme }) => ({
  width: 60,
  height: 25,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked .MuiSwitch-thumb': {
      position: "relative",
      right: "7px"
    },
    '&.Mui-checked .MuiSwitch-input': { left: "-160%" },

    '&.Mui-checked': {
      transform: 'translateX(40px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#C8172F',
        opacity: 1,
        '&::before': {
          content: '"Admin"', // Text for checked state
          left: 5,
          color: '#fff',
          fontSize: "10px"
        },
      },
    },
  },
  '& .MuiSwitch-thumb': {
    width: 22,
    height: 22,
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    borderRadius: 20,
    backgroundColor: '#ccc',
    opacity: 1,
    position: 'relative',
    '&::before': {
      content: '"Modu"', // Text for unchecked state
      position: 'absolute',
      top: '50%',
      right: "6px",
      transform: 'translateY(-50%)',
      fontSize: "10px",
      color: '#000',
    },
  },
}));
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const [notification, setNotification] =
    React.useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Toggle: close if already open with same target, else open
    if (anchorEl === event.currentTarget) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
      setNotification(null);
    }
  }
  const handleNotificationClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    if (notification) {
      // Close if already open
      setNotification(null);
    } else {
      // Open on click
      setNotification(event.currentTarget);
      setAnchorEl(null);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
    setNotification(null);
  };
  const open = Boolean(anchorEl);
  const openNotificationPopover = Boolean(notification);
  const navigate = useNavigate();
  const id = open ? "simple-popover" : undefined;
  const notificationPopoverId = openNotificationPopover
    ? "notify-popover"
    : undefined;
  const fname = localStorage.getItem("first_name");
  const lname = localStorage.getItem("last_name");
  const email = localStorage.getItem("email");
  console.log("email", email);
  // Popover for logout //
  const handleLogout = async () => {
    await Cookies.remove("loginToken");
    localStorage.removeItem("first_name");
    localStorage.removeItem("last_name");
    localStorage.removeItem("email");

    navigate("/login");
     
   

  };
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };
  console.log("checked", checked);
  useEffect(() => {
  if (!(mainroles.includes('Admin') && mainroles.includes('Module Owner'))) {
    setChecked(false);
  }
}, [mainroles]); 
  return (
    <MuiAppBar
      className="header"
      position="fixed"
      sx={{
        // zIndex: (theme) => theme.zIndex.drawer + 1,
        //zIndex: "9999 !important",
        background: "#FFF",
        boxShadow: "none",
        borderBottom: "1px solid rgba(231, 232, 233, 1)",
      }}
    >
      <Toolbar
        sx={{
          minHeight: "80px !important",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0 32px !important",
        }}
      >


        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            borderRight: "1px solid #E7E8E9",
            width: "243px",
            height: "80px",
          }}
        >
          {/* <IconButton sx={{background:"rgba(231, 232, 233, 1)"}} edge="start" color="inherit" aria-label="menu" onClick={onMenuClick}>
            <MenuIcon />
          </IconButton> */}
          <img src={logo} alt="logoooo" />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <TextField
            required
            id="outlined-required"
            placeholder="Search"
            sx={{
              ".MuiOutlinedInput-root": {
                border: "none",
                background: "rgba(245, 246, 247, 1)",
                borderRadius: "12px",
                height: "48px",
                color: "rgba(125, 126, 127, 1)",
                fontSize: "14px",
                fontWeight: "400",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <img
                    src={serachicon}
                    alt="search icon"
                    width="18"
                    height="18s"
                  />
                </InputAdornment>
              ),
            }}
          />
 {/* {(mainroles.includes('Admin') && mainroles.includes('Module Owner')) ? (
  <Box>
    <Box>
      <TextSwitch
        checked={checked}
        onChange={(e) => {
          setChecked(e.target.checked);
          navigate("/team-Members");
        }}
      />
    </Box>
  </Box>
) : null} */}

          <Button
            onClick={handleNotificationClick}
            sx={{
              background: openNotificationPopover ? "#FFEBEF" : "transparent",
              padding: openNotificationPopover ? "5px" : "0",
              borderRadius: openNotificationPopover ? "50%" : "0",
              minWidth: "unset",
              "&:hover": {
                backgroundColor: "transparent",
                boxShadow: "none",
              },
              "&:focus": {
                backgroundColor: "transparent",
                boxShadow: "none",
              },
            }}
          >
            <img src={bellicon} alt="bellicon" />
          </Button>
          <Button
            aria-describedby={id}
            variant="contained"
            onClick={handleClick}
            sx={{
              background: open ? "#FFEBEF" : "transparent",
              padding: open ? "5px" : "0",
              borderRadius: open ? "50%" : "0",
              minWidth: "unset",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "transparent",
                boxShadow: "none",
              },
              "&:focus": {
                backgroundColor: "transparent",
                boxShadow: "none",
              },
              ".MuiButton-root": { backgroundColor: "transperent !important" },
            }}
          >
            <img src={profileImg} alt="profile" />
          </Button>
          {/* Notification Popover */}
          <Popover
            id={notificationPopoverId}
            open={openNotificationPopover}
            anchorEl={notification}
            onClose={handleClose}
            sx={{ top: "35px", height: "440px" }}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
          >
            <Box sx={{ maxWidth: "400px" }}>
              <Typography variant="body1" sx={{ fontWeight: "400" }}>
                <Notifications />
              </Typography>
            </Box>
          </Popover>

          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            sx={{
              top: "35px",
              ".MuiButton-root": {
                backgroundColor: "transperent !important",
              },
            }}
          >
            <Box
              sx={{
                maxWidth: "500px",
                width: "375px",
                background: "#f9f9f9",
              }}
            >
              <Box
                sx={{
                  background:
                    " linear-gradient(0deg, rgb(200 23 47 / 12%) 0%, rgb(200 23 47 / 0%) 64%)",
                  borderRadius: "20px",
                  borderBottom: "1px solid #C8172F",
                  padding: "30px 0",
                }}
              >
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      color: "#B90022",
                      position: "relative",
                      padding: "20px 0",
                      fontSize: "32px",
                      "&::before": {
                        content: "' '",
                        display: "block",
                        width: "70px",
                        height: "70px",
                        border: "1px solid #B90022",
                        position: "absolute",
                        top: 0,
                        borderRadius: "50px",
                        transform: "translate(-50%, 10px)",
                        left: "50%",
                      },
                    }}
                  >
                    A
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#B90022",
                      fontSize: "32px",
                    }}
                  >
                    {fname} {lname}
                  </Typography>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#696A6B",
                      fontSize: "16px",
                    }}
                  >
                    {email}
                  </Typography>
                </Box>
              </Box>
              <Box>
                <Box sx={{ bgcolor: "#f9f9f9", padding: 2 }}>
                  <List
                    sx={{
                      width: "100%",

                      borderRadius: 2,
                    }}
                  >
                    {/* Activity Log */}
                    <ListItem
                      component="a"
                      href="/activity-log"
                      sx={{
                        mb: "20px",
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow: "none",
                        color: "#000"
                      }}
                    >
                      <ListItemIcon>
                        <Box
                          sx={{
                            bgcolor: "#FFEBEF80",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 40,
                            height: 40,
                          }}
                        >
                          <img src={ActivityIcon} alt="Activity" />
                        </Box>
                      </ListItemIcon>
                      <ListItemText sx={{ fontSize: "14px !important", fontWeight: "600 !important" }} primary="Activity log" />
                      <Tooltip title="Activity log">
                        <img src={Arrow} alt="right Arrow" />
                      </Tooltip>
                    </ListItem>

                    {/* Profile Setting */}
                    <ListItem
                      href="/ProfileSetting"
                      component="a"
                      sx={{
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow: "none",
                        color: "#000"
                      }}
                    >
                      <ListItemIcon>
                        <Box
                          sx={{
                            bgcolor: "#FFEBEF80",
                            borderRadius: 2,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "none",
                            width: 40,
                            height: 40,
                          }}
                        >
                          <img src={Setting} alt="Activity" />
                        </Box>
                      </ListItemIcon>
                      <ListItemText sx={{ ".MuiListItemText": { fontSize: "14px" } }} primary="Profile Setting" />
                      <Tooltip title="Profile Setting">
                        <img src={Arrow} alt="right Arrow" />
                      </Tooltip>
                    </ListItem>
                  </List>
                </Box>
              </Box>
              <Box sx={{ margin: "0 20px 20px", background: "none" }}>
                <Button
                  sx={{
                    color: "#C8172F",
                    background: "none",
                    padding: "8px 12px",
                    fontSize: "14px",
                    fontWeight: "500",
                    textTransform: "capitalize",
                    width: "100%",
                    height: "44px",
                    border: "1px solid #C8172F",
                  }}
                  onClick={() => handleLogout()}
                >
                  Logout
                </Button>
              </Box>
            </Box>
          </Popover>
        </Box>
      </Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
